import { ComponentType } from '../ui/shared/LinkTypes';
import { Context } from '../ui/shared/enums/Context';
import { UnderLineType } from '../ui/shared/enums/UnderLineType';
import { Direction } from '../ui/shared/enums/Direction';
import { Size } from '../ui/shared/enums/Size';
import { VisualStyle } from '../ui/shared/enums/VisualStyle';
/**
 * Default configuration for button components
 */
export const defaultInteractiveButtonElement = {
    link: '', // Add default value for link
    ariaLabel: '',
    componentType: ComponentType.Link, // Using enum for type safety
    isDisabled: false,
    text: '',
};
/**
 * Placeholder configuration for button components, for use in testing or development
 */
export const placeholderInteractiveButtonElement = {
    link: 'https://www.example.com', // Add default value for link
    ariaLabel: 'Some link Label', // Providing a meaningful aria-label for accessibility
    componentType: ComponentType.Link, // Using enum for type safety
    context: Context.Primary, // Using enum for context
    direction: Direction.Right, // Using enum for type safety
    isBlock: false,
    isDisabled: false,
    size: Size.Medium, // Using 'Md' for medium size; adjust as needed
    text: 'Some Descriptive Text For The Link',
    hoverColor: '', // Add default value for hoverColor
    isUnderLine: UnderLineType.OnHover,
    linkColor: Context.Secondary,
    visualStyle: VisualStyle.Highlighted,
};
//# sourceMappingURL=InteractiveButtonElement.js.map